import React, { useEffect, useState } from "react";
import { IconRight } from "../../assets/icons";
import { BoldText, Text, Card, Wrapper, TextWrapper } from "./DashboardStyled";
import { Col, message, Row } from "antd";
import api from "../../api/api";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Count = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  
  const {t} = useTranslation();

  const getDashboardCount = () => {
    setLoading(true);
    api
      .getDashboardCount()
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => message.error(err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getDashboardCount();
  }, []);

  const adminData = localStorage.getItem("admin");
  const admin = adminData ? JSON.parse(adminData) : null;
  const role = admin?.role;

  const handleCardClick = (route) => {
    if (role === "MERCHANT_ADMIN") {
      navigate(route, { state: "dashboard" });
    } else {
      message.warning("Access Denied!");
    }
  };

  return (
    <Row gutter={[12, 12]}>
      <Col xs={12} md={24}>
        <Card
          onClick={() => handleCardClick("/home/data-mgnt/user-management")}
        >
          <Wrapper>
            <TextWrapper>
              <Text>{t('total_customers')}</Text>
              <IconRight />
            </TextWrapper>
            <BoldText> {data?.total_customers ?? 0}</BoldText>
          </Wrapper>
        </Card>
      </Col>
      <Col xs={12} md={24}>
        <Card
          onClick={() => handleCardClick("/home/order-mgnt/orders/COMPLETED")}
        >
          <Wrapper>
            <TextWrapper>
              <Text>{t('total_orders')}</Text>
              <IconRight />
            </TextWrapper>
            <BoldText>{data?.total_orders ?? 0}</BoldText>
          </Wrapper>
        </Card>
      </Col>
      <Col xs={12} md={24}>
        <Card onClick={() => handleCardClick("/home/data-mgnt/categories")}>
          <Wrapper>
            <TextWrapper>
              <Text>{t('total_categories')}</Text>
              <IconRight />
            </TextWrapper>
            <BoldText>{data?.total_categories ?? 0}</BoldText>
          </Wrapper>
        </Card>
      </Col>
      <Col xs={12} md={24}>
        <Card onClick={() => handleCardClick("/home/data-mgnt/products")}>
          <Wrapper>
            <TextWrapper>
              <Text>{t('total_products')}</Text>
              <IconRight />
            </TextWrapper>
            <BoldText>{data?.total_products ?? 0}</BoldText>
          </Wrapper>
        </Card>
      </Col>
    </Row>
  );
};

export default Count;
